import type { TOC } from '@ember/component/template-only';
import { eq } from 'ember-truth-helpers';
import GeneralIconWithTooltip from 'lumen/components/general/icon-with-tooltip';

interface GeneralTablesCellsThIconWithTooltipSignature {
  Args: {
    column: {
      name: string;
      textAlign: string;
      tooltip: { content: string; title: string };
    };
  };
}

const GeneralTablesCellsThIconWithTooltip = <template>
  <span
    class="{{if (eq @column.textAlign 'center') 'flex justify-center'}}
      {{if (eq @column.textAlign 'right') 'flex justify-end'}}
      text-200--bold flex items-center gap-100"
  >
    {{@column.name}}
    <GeneralIconWithTooltip
      @tooltipContent={{@column.tooltip.content}}
      @tooltipTitle={{@column.tooltip.title}}
    />
  </span>
</template> satisfies TOC<GeneralTablesCellsThIconWithTooltipSignature>;

export default GeneralTablesCellsThIconWithTooltip;
